/**
 * MetaData base class to be used for some meta information like type of request etc..
 */
export class MetaData {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param metaData
     */
    constructor(metaData) {
        this._metaData = metaData;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {MetaData}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.metaData = values.metaData !== undefined ? values.metaData : {};
        return new MetaData(sanitizedValues.metaData);
    }
    /**
     * gets the internal _metaData
     * @returns {string}
     */
    get metaData() {
        return this._metaData;
    }
    /**
     * sets the internal _metaData
     */
    set metaData(value) {
        this._metaData = value;
    }
}
//# sourceMappingURL=MetaData.js.map